export default __webpack_public_path__ + "static/media/desktop.1a050ce5.png";